<template>
  <div class="wrapper flex-row align-center justify-center full-parent">
    <div class="info-block flex-column align-start justify-start">
      <slideInfo
        title="健康体检#疫情期间严格防范"
        desc="健康问题严格把关，所有月嫂定期进行第一健康的全方位体检，疫情期间持续进行健康打卡，确保月嫂身体健康"
        buttonText="找月嫂"
      />
    </div>

    <swiper
      class="bg-block"
      :lazy="{ loadPrevNext: true }"
      :autoplay="{ delay: 3000 }"
      :speed="3000"
      effect="fade"
      :simulateTouch="false"
    >
      <swiper-slide
        class="full-parent"
        v-for="(item, index) of imgList"
        :key="index"
      >
        <img
          class="img full-parent skeleton swiper-lazy"
          draggable="false"
          :data-src="item"
        />
        <div class="swiper-lazy-preloader" />
      </swiper-slide>
    </swiper>

    <decorate :list="decorateList" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import slideInfo from "../slide-info/slide-info.vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Autoplay, EffectFade, Lazy } from "swiper";
require("swiper/swiper.less");
require("swiper/components/effect-fade/effect-fade.less");
require("swiper/components/lazy/lazy.less");

const SWIPER_COMPONENTS = {
  Swiper,
  SwiperSlide,
};

SwiperCore.use([Autoplay, EffectFade, Lazy]);
export default defineComponent({
  components: {
    slideInfo,
    ...SWIPER_COMPONENTS
  },

  data() {
    return {
      imgList: [
        'https://mm2015.mamalaile.com.cn/413df99c0435ec4a9d7c3d5facaf17bc.jpg',
        'https://mm2015.mamalaile.com.cn/c91543e6d7b915abe1a58cc6506a73ba.jpg',
        'https://mm2015.mamalaile.com.cn/09a8c8b5fcf6c2748e2906b6ea601ff0.jpg',
        'https://mm2015.mamalaile.com.cn/8de2b883c03583e47e02c06f5bf5eb50.jpg',
      ],
      decorateList: [
        { position: 'bottom-left', url: require('/src/assets/images/home_pic2_bg@2x.png'), width: 28.07 },
      ]
    };
  }
});
</script>

<style lang="less" scoped>
.wrapper {
  position: relative;

  .info-block {
    width: 100%;
    padding-left: 9.43vw;
  }

  .bg-block {
    width: 58.28vw;
    height: 100%;
    flex-shrink: 0;

    .img {
      object-fit: cover;
    }
  }
}
</style>